let timelineElements = [
  {
    id: 1,
    title: "Algorizz",
    location: "Full Stack Developer",
    description: [
      "Developed Patient and Driver Mobile Apps and Website remotely.",
      "Created responsive and reusable components for the Algorizz Website using React.js and Tailwind CSS.",
      "Developed a Patient App with doctor appointment booking, medicine ordering, cart management with Razorpay integration, wishlist functionality, and lab test requests using React Native.",
      "Implemented real-time medicine delivery tracking and push notifications using Firebase Cloud Messaging.",
      "Led end-to-end development and deployment of the Driver App, supporting multiple login types and delivery workflows.",
      "Integrated Mapbox for in-app navigation with Turn-by-Turn Voice Navigation, ETA, and Live View.",
      "Enabled drivers to manage ongoing and upcoming deliveries with dashboards and instant delivery alerts.",
      "Collaborated with designers and backend developers to ensure UI consistency, high performance, and design fidelity.",
      "Have Apps Deployment experience to the Google Play Store.",
    ],
    buttonText: "Visit Website",
    link: "https://algorizz.com/",
    date: "May 2025 – October 2025",
    icon: "work",
  },
  {
    id: 2,
    title: "Logistos",
    location: "Full Stack Developer Intern",
    description: [
      "Built scalable logistics solutions and cross-platform mobile app.",
      "Developed custom dashboard for managing shipments, pickups, warehouses, and invoices for website and app.",
      "Led development of a cross-platform Logistics App using React Native (Expo), deployed on Google Play Store.",
      "Implemented core features: create shipments, view shipment list, manage warehouses and pickups, and check serviceability.",
      "Integrated Rate Calculator and automated invoice generation.",
      "Added real-time updates with parcel tracking, delivery status, and push notifications using Firebase.",
      "Collaborated on backend integration using Python Flask APIs, AWS S3, and planned cloud deployment with EC2 and RDS.",
      "Optimized website performance with reusable React components for dashboard and UI views.",
    ],
    buttonText: "Visit Website",
    link: "https://logistos.in/",
    date: "Mar 2025 – Apr 2025",
    icon: "work",
  },
  {
    id: 3,
    title: "MokkoMotto",
    location: "Full Stack Developer",
    description: [
      "Led migration of website from WordPress to Next.js and MERN stack.",
      "Directed team to modernize website architecture, improving scalability and performance.",
      "Developed responsive Next.js components including a dynamic cart system; optimized pages improved site visibility by 30%.",
      "Built admin panel using React/Next.js for shipment management, booking workflows, analytics dashboards, and user management.",
      "Converted UX designs into modular components supporting admin and user workflows.",
      "Integrated Google/Facebook authentication, secure user dashboard, password reset, and Razorpay payment processing.",
      "Deployed scalable platform on AWS (EC2, S3, RDS, Load Balancer) handling 10,000+ concurrent users.",
      "Ensured UI consistency, performance, and design fidelity across user-facing and admin interfaces.",
    ],
    buttonText: "Visit Website",
    link: "https://mokkomotto.com/",
    date: "Sep 2024 – Jan 2025",
    icon: "work",
  },
  {
    id: 4,
    title: "NapFT Technology",
    location: "Full Stack Developer",
    description: [
      "Designed, developed, and deployed a responsive NFT marketplace platform remotely.",
      "Built production-ready MERN stack application: React.js, Node.js/Express.js, MongoDB, Redis.",
      "Integrated frontend with smart contracts for NFT creation, listing, and management.",
      "Managed development using Atlassian Jira and coordinated with cross-functional teams.",
      "Deployed application on AWS EC2 with static assets hosted on S3.",
      "Implemented wallet connection and transaction handling for minting, buying, and selling NFTs.",
    ],
    buttonText: "Check Website",
    link: "https://napft.com/",
    date: "Jan 2024 – July 2024",
    icon: "work",
  },
  {
    id: 5,
    title: "Bharat Intern",
    location: "Full-stack Developer",
    description: [
      "Working hand-in-hand with front-end developers by providing the outward facing web application elements server-side logic.",
      "Creating the logic to make the web app function properly, and accomplishing this through the use of server-side scripting languages.",
    ],
    buttonText: "See Details",
    link: "https://www.linkedin.com/in/satyapriya-mishra-3a95a4223/overlay/1710303540372/single-media-viewer/?profileId=ACoAADgmczEBl_BqlWCCAY4UsN6FygWK5CQQOJo",
    date: "Mar 2024 - April 2024",
    icon: "work",
  },
  {
    id: 6,
    title: "Mood Indigo IIT Bombay",
    location: "Indigo Tech Management Member",
    description: [
      "Assessing the quality of specifications and technical design documents in order to ensure timely, relevant and meaningful feedback.",
    ],
    buttonText: "See Details",
    link: "https://www.linkedin.com/in/satyapriya-mishra-3a95a4223/overlay/1635507549064/single-media-viewer/?profileId=ACoAADgmczEBl_BqlWCCAY4UsN6FygWK5CQQOJo",
    date: "Nov 2022 - Dec 2022",
    icon: "work",
  },
  {
    id: 7,
    title: "Writistic Studio Startup",
    location: "Frontend Graphic Editor",
    description: [
      "Converting data to a graphical interface, through the use of HTML, CSS, and JavaScript, so that users can view and interact with that data.",
    ],
    buttonText: "See Details",
    link: "https://www.linkedin.com/in/satyapriya-mishra-3a95a4223/overlay/1635507831103/single-media-viewer/?profileId=ACoAADgmczEBl_BqlWCCAY4UsN6FygWK5CQQOJo",
    date: "Oct 2022 - Mar 2023",
    icon: "work",
  },
  {
    id: 8,
    title: "Silicon University",
    location: "BTech. CSE",
    description: [],
    buttonText: "College",
    link: "https://drive.google.com/file/d/1GR4K7rl2tcDo5kZ2JVclon905bhLQIj1/view?usp=sharing",
    date: "Dec 2021 - Jun 2025",
    icon: "school",
  },
  {
    id: 9,
    title: "Jhadeswar +2 Sc. Residential College",
    location: "Intermediate study",
    description: [],
    buttonText: "College",
    link: "http://jsrcbalasore.org/",
    date: "2019 - 2021",
    icon: "school",
  },
];

export default timelineElements;
